import { AltTextFailedReason } from '../types';
import { hasImageExtension } from './has-image-extension';
export const getAlternativeTextCardReason = text => {
  const formattedText = text.toLowerCase().trim();
  if (formattedText === '') {
    return AltTextFailedReason.EmptyAltText;
  }
  if (hasImageExtension(formattedText)) {
    return AltTextFailedReason.HasImageExtension;
  }
  return;
};
//# sourceMappingURL=get-alt-text-failure-reason.js.map